
import { MediaOwnerPricingConstants } from './types';

// Attention pricing is location-specific in our dataset; the default matches the most common "Digital megacom" rate.
export const ATTENTION_DEFAULT_COST_PER_DEVICE_PER_DAY = 1286;

export const attentionPricingConstants: MediaOwnerPricingConstants = {
  // Map data uses: "Price: 1,286 SAR per face per day" for 1-face screens.
  // We treat "device/screen" == "face" for these locations, so the budget matches the map.
  costPerDevicePerDay: ATTENTION_DEFAULT_COST_PER_DEVICE_PER_DAY,
  discountScreensThreshold: 10,
  baseDiscountRate: 0.05, // 5% base discount
  maxDiscountRate: 0.20, // 20% max discount
};

